import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import DialogDefinition from '../../../models/DialogDefinition';

const initialState: DialogDefinition = {
 height: 0,
 width: 0,
};

export const dialogEmailComponentSlice = createSlice({
 name: 'dialogEmailComponent',
 initialState,
 reducers: {
  dialogEmailComponent: (state, action: PayloadAction<any>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { dialogEmailComponent } = dialogEmailComponentSlice.actions;

export default dialogEmailComponentSlice.reducer;
